import React, { useEffect, useState } from "react";
import { FaUserPlus } from "react-icons/fa";
import { FaRegBuilding } from "react-icons/fa";
import { FaUserSecret } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { FaCogs } from "react-icons/fa";
import { FaTicketAlt } from "react-icons/fa";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import io from "socket.io-client";
import { useTab } from "../../context/TabContext";

const socket = io(process.env.REACT_APP_SOCKET_URL);

export default function Migration({setCount, count}) {

  const { setActiveTab } = useTab();
  const source = localStorage.getItem("source");
  const destination = localStorage.getItem("destination");
  const capitalSource = source.toUpperCase();
  const capitalDestination = destination.toUpperCase();
  const accessToken = localStorage.getItem("accessToken");
  const [isMigrating, setIsMigrating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mainProgress, setMainProgress] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      activateLoader();
      console.log("SDSD ");

      const sourceData = await getCountData();

      setCount((prevCount) => ({
        ...prevCount,
        orgsSourceCount: sourceData.orgCount,
        groupsSourceCount: sourceData.groupCount,
        agentsSourceCount: sourceData.agentsCount,
        usersSourceCount: sourceData.usersCount,
        fieldsSourceCount: sourceData.cfCount,
        ticketsSourceCount: sourceData.ticketsCount,
      }));

      console.log("SDSD* ");
      deactivateLoader();
    };

    fetchData();
  }, []);

  useEffect(() => {
    socket.on("progressUpdate", async (data) => {
      await updateProgressBar(
        data.module,
        data.count,
        data.totalCount,
        data.clientId,
        data.migrationId,
        data.individualPercentage
      );
    });

    return () => {
      socket.off("progressUpdate");
    };
  }, [socket]);

  useEffect(() => {
    socket.on("serverMessage", async (data) => {

      console.log("Server message get called..");
      await updateProgressBar(
        data.module,
        data.count,
        data.totalCount,
        data.clientId,
        data.migrationId,
        data.individualPercentage
      );
    });

    return () => {
      socket.off("serverMessage");
    };
  }, [socket]);

  const activateLoader = () => {
    setIsLoading(true);
  };

  const deactivateLoader = () => {
    setIsLoading(false);
  };

  const getCountData = async () => {
    const countApiUrl = process.env.REACT_APP_COUNT_API;
    console.log("sfd ", countApiUrl);

    const payload = {
      clienId: localStorage.getItem("clientId"),
      migrationId: localStorage.getItem("migrationId"),
    };
    console.log("PAYLOAD ", payload);
    const countResposne = await axios.post(countApiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    console.log("SDS ", countResposne);
    if (countResposne) {
      const countData = await countResposne.data;

      if (countData.status === 200) {
        console.log("DATA ", countData.data);
        return countData.data;
      } else {
        return {
          usersCount: 0,
          orgCount: 0,
          groupCount: 0,
          cfCount: 0,
          agentsCount: 0,
          ticketsCount: 0,
        };
      }
    }
  };

  const migrationCall = async (moduleName) => {
    const zdk_domain_verification_url = process.env.REACT_APP_MODULE_API;

    // try {
    const payload = {
      clientId: localStorage.getItem("clientId"),
      migrationId: localStorage.getItem("migrationId"),
      moduleName: moduleName,
    };

    console.log("PAYLOAD ", payload);


    const ModuleResposne = await axios.post(zdk_domain_verification_url, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if(ModuleResposne){
      const moduleData = await ModuleResposne.data;
      if(moduleData.status === 200){
        console.log("Api return succeedd..")
        return {
          status: 200,
          message: "Success"
        };

      }
      else{
        console.log("Api will not return succeedd..")
        return {
          status: 400,
          message: "Success"
        };
      }
    }



    return {
      status: 500,
      message: "Success"
    };


  }

  async function updateProgressBar(
    moduleName,
    socketValues,
    totalCount,
    clientId,
    migrationId,
    percentage
  ) {
    if (
      localStorage.getItem("clientId") === clientId &&
      localStorage.getItem("migrationId") === migrationId
    ) {
      if (moduleName !== "newAgent" && moduleName !== "newUser") {
        if (moduleName.startsWith("overall")) {
          let cumulativeCount = socketValues;
          let progress = (cumulativeCount / 12) * 100;
          progress = Math.min(progress, 100);

          let progressBar = document.getElementById("mainProgressBar");
          progressBar.style.width = progress + "%";
          setMainProgress(progress);
          if(moduleName === "overall_pushTickets"){
            console.log("Overall_pushTickets block get executed..");
            setTimeout(()=>{
              setActiveTab("4");
            },2000)
          }
        }

        if (moduleName === "agents") {
          console.log("AgentsProgressBar")
          const nowprogress = document.getElementById("getTfProgressBar");
          nowprogress.style.width = percentage + "%";

          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-green");
          }
        }

        if (moduleName === "users") {
          console.log("usersProgressBar")
          const nowprogress = document.getElementById("getTicketsProgressBar");
          nowprogress.style.width = percentage + "%";

          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-green");
          }
        }

        if (moduleName === "ticketfields") {
          console.log("ticketfieldsProgressBar")
          const nowprogress = document.getElementById("getOrgsProgressBar");
          nowprogress.style.width = percentage + "%";

          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-green");
          }
        }

        if (moduleName === "tickets") {
          console.log("ticketsProgressBar")
          const nowprogress = document.getElementById("getGroupsProgressBar");
          nowprogress.style.width = percentage + "%";

          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-green");
          }
        }

        if (moduleName === "organizations") {
          console.log("OrganizationProgressBar")
          const nowprogress = document.getElementById("getAgentsProgressBar");
          nowprogress.style.width = percentage + "%";

          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-green");
          }
        }

        if (moduleName === "groups") {
          console.log("groupsProgressBar")
          const nowprogress = document.getElementById("getUsersProgressBar");
          nowprogress.style.width = percentage + "%";

          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-green");
          }
        }

        if (moduleName === "pushOrganizations") {
          console.log("pushOrganizationProgressBar",)
          const dest = localStorage.getItem("destination");
          document.getElementById(
            "progressBarText"
          ).innerHTML = `Migrating ${dest} Data `;

          setCount((prevCount) => ({
            ...prevCount,
            orgsDestinationCount:totalCount
          
          }));
          // document.getElementById("orgMigratedCount").innerHTML = totalCount;
          // document.getElementById("orgMigratedCount1").innerHTML = totalCount;

          const nowprogress = document.getElementById("postOrgProgressBar");
          nowprogress.style.width = percentage + "%";
          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-blue");
          }
        }

        if (moduleName === "pushGroups") {
          console.log("PushGroupsProgressBar")
          const dest = localStorage.getItem("destination");
          document.getElementById(
            "progressBarText"
          ).innerHTML = `Migrating ${dest} Data `;
          setCount((prevCount) => ({
            ...prevCount,
            groupsDestinationCount:totalCount
          
          }));
          // document.getElementById("groupMigratedCount").innerHTML = totalCount;
          // document.getElementById("groupMigratedCount1").innerHTML = totalCount;

          const nowprogress = document.getElementById("postGroupProgressBar");
          nowprogress.style.width = percentage + "%";
          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-blue");
          }
        }

        if (moduleName === "pushAgents") {
          console.log("PushAgentsProgressBar")
          const dest = localStorage.getItem("destination");
          document.getElementById(
            "progressBarText"
          ).innerHTML = `Migrating ${dest} Data `;

          setCount((prevCount) => ({
            ...prevCount,
            agentsDestinationCount:totalCount
          
          }));
          // document.getElementById("agentMigratedCount").innerHTML = totalCount;
          // document.getElementById("agentMigratedCount1").innerHTML = totalCount;

          const nowprogress = document.getElementById("postAgentProgressBar");
          nowprogress.style.width = percentage + "%";
          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-blue");
          }
        }

        if (moduleName === "pushUsers") {
          console.log("PushUserProgressBar")
          const dest = localStorage.getItem("destination");
          document.getElementById(
            "progressBarText"
          ).innerHTML = `Migrating ${dest} Data `;
          
          setCount((prevCount) => ({
            ...prevCount,
            usersDestinationCount:totalCount
          
          }));
          // document.getElementById("userMigratedCount").innerHTML = totalCount;
          // document.getElementById("userMigratedCount1").innerHTML = totalCount;

          const nowprogress = document.getElementById("postUserProgressBar");
          nowprogress.style.width = percentage + "%";
          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-blue");
          }
        }

        if (moduleName === "pushTicketfields") {
          console.log("pushticketfieldsProgressBar")
          const dest = localStorage.getItem("destination");
          document.getElementById(
            "progressBarText"
          ).innerHTML = `Migrating ${dest} Data `;

          setCount((prevCount) => ({
            ...prevCount,
            fieldsDestinationCount:totalCount
          
          }));
          
          // document.getElementById("fieldMigratedCount").innerHTML = totalCount;
          // document.getElementById("fieldMigratedCount1").innerHTML = totalCount;

          const nowprogress = document.getElementById("postTfProgressBar");
          nowprogress.style.width = percentage + "%";
          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-blue");
          }
        }

        if (moduleName === "pushTickets") {
          console.log("pushTicketsProgressBar")
          const dest = localStorage.getItem("destination");
          document.getElementById(
            "progressBarText"
          ).innerHTML = `Migrating ${dest} Data `;

          setCount((prevCount) => ({
            ...prevCount,
            ticketsDestinationCount:totalCount
          
          }));
          document.getElementById("ticketMigratedCount").innerHTML = totalCount;
          document.getElementById("ticketMigratedCount1").innerHTML =
            totalCount;

          const nowprogress = document.getElementById("postTicketsProgressBar");
          nowprogress.style.width = percentage + "%";
          if (percentage === "100.00") {
            nowprogress.classList.remove("progress-bar");
            nowprogress.classList.add("progress-bar-blue");
            document.getElementById(
              "progressBarText"
            ).innerHTML = `Migration Completed Successfully `;

            // const finalCountData = await getCounts(migrationId, clientId);
            // finalCountData.status === 200 &&
            //   ((document.getElementById("orgMigratedCount2").innerHTML =
            //     finalCountData.finalCount.orgCount),
            //   (document.getElementById("groupMigratedCount2").innerHTML =
            //     finalCountData.finalCount.groupCount),
            //   (document.getElementById("agentMigratedCount2").innerHTML =
            //     finalCountData.finalCount.agentsCount),
            //   (document.getElementById("userMigratedCount2").innerHTML =
            //     finalCountData.finalCount.userCount),
            //   (document.getElementById("fieldMigratedCount2").innerHTML =
            //     finalCountData.finalCount.cfCount),
            //   (document.getElementById("ticketMigratedCount2").innerHTML =
            //     finalCountData.finalCount.ticketsCount));
          }
        }
      } else if (moduleName === "newAgent") {
        const presentAgentMigratedElement =
          document.getElementById("agentMigratedCount");
        let presentAgentMigratedValue = parseInt(
          presentAgentMigratedElement.textContent,
          10
        );

        presentAgentMigratedValue += 1;

        document.getElementById("agentMigratedCount").innerHTML =
          presentAgentMigratedValue;
        document.getElementById("agentMigratedCount1").innerHTML =
          presentAgentMigratedValue;
        document.getElementById("agentMigratedCount2").innerHTML =
          presentAgentMigratedValue;
      } else if (moduleName === "newUser") {
        const presentUserMigratedElement =
          document.getElementById("userMigratedCount");
        let presentUserMigratedValue = parseInt(
          presentUserMigratedElement.textContent,
          10
        );

        presentUserMigratedValue += 1;

        document.getElementById("userMigratedCount").innerHTML =
          presentUserMigratedValue;
        document.getElementById("userMigratedCount1").innerHTML =
          presentUserMigratedValue;
        document.getElementById("userMigratedCount2").innerHTML =
          presentUserMigratedValue;
      }
    }
  }

  const handleMigrateClick = async () => {
    console.log("The handle function get called");

    document.getElementById("migrate").style.display = "none";
    document.getElementById("show-progress").style.display = "block";
    const fetchingSource = localStorage.getItem('source')
    document.getElementById(
      "progressBarText"
    ).innerHTML = `Fetching ${fetchingSource} Data `;
    // Set initial progress bar width to 0% to start as empty
    let progressBar = document.querySelector(".progress-bar");
     progressBar.style.width = "0%";
     progressBar.style.height ="30px";

    //left
    document.getElementById("org-count").style.display = "none";
    document.getElementById("org-progress").style.display = "block";

    document.getElementById("group-count").style.display = "none";
    document.getElementById("group-progress").style.display = "block";

    document.getElementById("agent-count").style.display = "none";
    document.getElementById("agent-progress").style.display = "block";

    document.getElementById("user-count").style.display = "none";
    document.getElementById("user-progress").style.display = "block";

    document.getElementById("field-count").style.display = "none";
    document.getElementById("field-progress").style.display = "block";

    document.getElementById("ticket-count").style.display = "none";
    document.getElementById("ticket-progress").style.display = "block";

    //right
    document.getElementById("org-count1").style.display = "none";
    document.getElementById("org-progress1").style.display = "block";

    document.getElementById("group-count1").style.display = "none";
    document.getElementById("group-progress1").style.display = "block";

    document.getElementById("agent-count1").style.display = "none";
    document.getElementById("agent-progress1").style.display = "block";

    document.getElementById("user-count1").style.display = "none";
    document.getElementById("user-progress1").style.display = "block";

    document.getElementById("field-count1").style.display = "none";
    document.getElementById("field-progress1").style.display = "block";

    document.getElementById("ticket-count1").style.display = "none";
    document.getElementById("ticket-progress1").style.display = "block";
    await migrationCall("fetchticketfields");
    setIsMigrating(true);
  };

  return (
    <>
      <div className="flex justify-center">
        <div className="w-[800px]">
          <div className="flex justify-center items-center gap-[10px]">
            <div className="flex items-center justify-start">
              <img src="/images/trans_zen.png" className="w-[7.5em]" />
              <p
                className="text-[18px] text-[#2e496f] font-[500]"
                style={{ margin: "0" }}
              >
                ZENDESK
              </p>
            </div>
            <div className="w-[45%]">
              <hr
                style={{
                  borderStyle: "dashed",
                  boderwidth: "1.5px",
                  borderColor: "#2e496f",
                }}
              />
            </div>
            <div className="flex items-center justify-start">
              <img src="/images/fresh.svg" className="w-[4em]" />
              <p
                className="text-[18px] text-[#2e496f] font-[500]"
                style={{ margin: "0", marginLeft: "10px" }}
              >
                FRESHDESK
              </p>
            </div>
          </div>
          <div className="mt-10 grid grid-cols-3 items-center">
            <div className="flex justify-center">
              <div>
                <div id="org-progress" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="getOrgsProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaRegBuilding className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">ORGS</p>
                    <span className="migrated-para">:</span>
                    <p className="migrated-para" id="orgCount">{count.orgsSourceCount}</p>
                  </div>
                </div>

                <div id="org-count" className="flex items-center gap-[15px] mt-3">
                  <FaRegBuilding className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">ORGS</p>
                  <span>:</span>
                  <p className="migrate-para" id="orgCount1">{count.orgsSourceCount}</p>
                </div>

                <div id="group-progress" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="getGroupsProgressBar"></div>
                    </div>
                  </div>


                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaUserPlus className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">GROUPS</p>
                    <span className="migrated-para">:</span>
                    <p className="migrated-para" id="groupCount">{count.groupsSourceCount}</p>
                  </div>
                </div>

                <div id="group-count" className="flex items-center gap-[15px] mt-3">
                  <FaUserPlus className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">GROUPS</p>
                  <span>:</span>
                  <p className="migrate-para" id="groupCount1">{count.groupsSourceCount}</p>
                </div>

                <div id="agent-progress" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="getAgentsProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaUserSecret className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">AGENTS</p>
                    <span className="migrated-para">:</span>
                    <p className="migrated-para" id="agentCount">{count.agentsSourceCount}</p>
                  </div>
                </div>

                <div id="agent-count" className="flex items-center gap-[15px] mt-4">
                  <FaUserSecret className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">AGENTS</p>
                  <span>:</span>
                  <p className="migrate-para" id="agentCount1">{count.agentsSourceCount}</p>
                </div>

                <div id="user-progress" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="getUsersProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaUsers className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">USERS</p>
                    <span className="migrated-para">:</span>
                    <p className="migrated-para" id="userCount">{count.usersSourceCount}</p>
                  </div>
                </div>

                <div id="user-count" className="flex items-center gap-[15px] mt-4">
                  <FaUsers className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">USERS</p>
                  <span>:</span>
                  <p className="migrate-para" id="userCount1">{count.usersSourceCount}</p>
                </div>

                <div id="field-progress" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="getTfProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaCogs className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">FIELDS</p>
                    <span className="migrated-para">:</span>
                    <p className="migrated-para" id="fieldCount">{count.fieldsSourceCount}</p>
                  </div>
                </div>

                <div id="field-count" className="flex items-center gap-[15px] mt-4">
                  <FaCogs className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">FIELDS</p>
                  <span>:</span>
                  <p className="migrate-para" id="fieldCount1">{count.fieldsSourceCount}</p>
                </div>

                <div id="ticket-progress" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="getTicketsProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaTicketAlt className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">TICKETS</p>
                    <span className="migrated-para">:</span>
                    <p className="migrated-para" id="ticketCount">{count.ticketsSourceCount}</p>
                  </div>
                </div>
                <div id="ticket-count" className="flex items-center gap-[15px] mt-4">
                  <FaTicketAlt className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">TICKETS</p>
                  <span>:</span>
                  <p className="migrate-para" id="ticketCount1">{count.ticketsSourceCount}</p>
                </div>
              </div>
            </div>

            <div>
              {!isMigrating && (
                <div id="migrate" className="flex justify-center Migrate-section">
                  <button className="custom-btn" onClick={handleMigrateClick}>
                    Migrate
                  </button>
                </div>
              )}

              {/* {isMigrating && (
                <div className="flex justify-center progress-section">
                  <div>
                    <p className="text-[13px] text-center text-[#484848] font-[500] mb-1">
                      Groups to Groups Migrating
                    </p>
                    <div className="progress progress-striped">
                      <div
                        className="progress-bar"
                        style={{ width: `${mainProgress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              )} */}

              <div id="show-progress" className="hidden">
                <p
                  style={{
                    fontSize: '13px',
                    textAlign: 'center',
                    color: '#484848',
                    fontWeight: 500,
                  }}
                  id="progressBarText"
                >
                  {/* Add any progress bar text here */}
                </p>
                <div >
                  <div className="progress progress-striped ">
                    <div className="progress-bar " id="mainProgressBar">
                      {/* You can dynamically update the progress bar width here if needed */}
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div className="flex justify-center">
              <div>
                <div id="org-progress1" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="postOrgProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaRegBuilding className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">ORGS</p>
                    <p className="migrated-para" id="orgMigratedCount">
                      {count.orgsDestinationCount}
                    </p>
                  </div>
                </div>

                <div id="org-count1" className="flex items-center gap-[15px] mt-3">
                  <FaRegBuilding className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">ORGS</p>
                  <p className="migrate-para" id="orgMigratedCount1">{count.orgsDestinationCount}</p>
                </div>

                <div id="group-progress1" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="postGroupProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaUserPlus className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">GROUPS</p>
                    <p className="migrated-para" id="groupMigratedCount">
                      {count.groupsDestinationCount}
                    </p>
                  </div>
                </div>

                <div id="group-count1" className="flex items-center gap-[15px] mt-3">
                  <FaUserPlus className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">GROUPS</p>
                  <p className="migrate-para" id="groupMigratedCount1">{count.groupsDestinationCount}</p>
                </div>

                <div id="agent-progress1" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="postAgentProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaUserSecret className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">AGENTS</p>
                    <p className="migrated-para" id="agentMigratedCount">
                      {count.agentsDestinationCount}
                    </p>
                  </div>
                </div>
                <div id="agent-count1" className="flex items-center gap-[15px] mt-4">
                  <FaUserSecret className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">AGENTS</p>
                  <p className="migrate-para" id="agentMigratedCount1">{count.agentsDestinationCount}</p>
                </div>

                <div id="user-progress1" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar h-[30px]" id="postUserProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaUsers className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">USERS</p>
                    <p className="migrated-para" id="userMigratedCount">
                      {count.usersDestinationCount}
                    </p>
                  </div>
                </div>
                <div id="user-count1" className="flex items-center gap-[15px] mt-4">
                  <FaUsers className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">USERS</p>
                  <p className="migrate-para" id="userMigratedCount1">{count.usersDestinationCount}</p>
                </div>

                <div id="field-progress1" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar  h-[30px]" id="postTfProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaCogs className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">FIELDS</p>
                    <p className="migrated-para" id="fieldMigratedCount">
                      {count.fieldsDestinationCount}
                    </p>
                  </div>
                </div>
                <div id="field-count1" className="flex items-center gap-[15px] mt-4">
                  <FaCogs className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">FIELDS</p>
                  <p className="migrate-para" id="fieldMigratedCount1">{count.fieldsDestinationCount}</p>
                </div>

                <div id="ticket-progress1" className="hidden relative w-[200px] mt-3">
                  <div>
                    <div className="progress progress-striped h-[30px]">
                      <div className="progress-bar h-[30px]" id="postTicketsProgressBar"></div>
                    </div>
                  </div>
                  <div className="flex items-center gap-[15px] absolute top-[5px] left-[10px]">
                    <FaTicketAlt className="text-[20px] text-[#fff]" />
                    <p className="migrated-para w-[60px]">TICKETS</p>
                    <p className="migrated-para" id="ticketMigratedCount">
                      {count.ticketsDestinationCount}
                    </p>
                  </div>
                </div>
                <div id="ticket-count1" className="flex items-center gap-[15px] mt-4">
                  <FaTicketAlt className="text-[20px] text-[#2f4a83]" />
                  <p className="migrate-para w-[60px]">TICKETS</p>
                  <p className="migrate-para" id="ticketMigratedCount1">
                    {count.ticketsDestinationCount}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div   style={{ display:"flex",justifyContent:"center" }} style="display: flex;
                    justify-content: center;">
            <div  style=" border-left: 3px solid #ffb60b;
                          padding: 3px 10px;
                          border-radius: 0px;
                          background: #ffffc1;
                          width: 47%;position:absolute;bottom:0;">
              <p style="    text-align: center;
                            margin: 0;
                            font-size: 12px;
                            color: #5c5c5c;">
                <i class="fa fa-info-circle" style="
                                color: #ff9900;
                                font-size: 16px;
                                margin-right: 5px;
                            ">
                </i>Note: Only the first 10 tickets will be migrated along with their associated properties, including
                contacts, organizations, groups, agents, and other related data.
              </p>
            </div>
          </div> */}
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255,255)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
            }}
          >
            <ClipLoader color="#36d7b7" size={50} />
          </div>
        )}
      </div>
    </>
  );
}
